<template>
    <div>
        <modal
                :width="500"
                height="auto"
                name="m-range">
            <div class="modal-dialog abtg-modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title abtg__modal-title" >Imposta il range dei Mq</h5>

                        <div class="tools">
                            <div class="abtg__close-button"><a @click="closeModal()"><i
                                    class="fas fa-times"></i></a></div>
                        </div>
                    </div>
                    <form @submit.prevent="onSubmit()">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" name="price" type="text"
                                               v-model="rangeData.min"
                                        >
                                        <label class="abtg__label-select">Min<span
                                                class="abtg__asterisk">*</span></label>
                                        <p class="text-danger small "></p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"

                                    >
                                        <input class="mdl-textfield__input abtg__input" name="price" type="text"
                                               v-model="rangeData.max"
                                        >
                                        <label class="abtg__label-select">Max<span
                                                class="abtg__asterisk">*</span></label>
                                        <p class="text-danger small "></p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="modal-footer">

                            <button type="submit" class="margin-right-10 btn-success float-right abtg__btn-star">
                                Salva
                            </button>
                            <div style="margin-bottom:30px;height:30px;">&nbsp;</div>
                        </div>
                        <div class="modal-body">
                            <div class="container">
                                <div class="row">
                                    <div class="col"><h3>Intervalli creati per questa zona</h3></div>
                                </div>
                                <div class="row">
                                    <table class="table">
                                        <tr v-for="r in content.customRange">
                                            <td>{{r.min}} / {{r.max}}</td>
                                            <td>
                                                <a

                                                        @click="deleteCustomRange(r.id)">
                                                    <i class="far fa-trash-alt  "></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </modal>
    </div>

</template>
<script>
    export default {
        props: ['content'],
        data() {
            return {
                rangeData: {},
            }
        },

        methods: {
            onSubmit: function () {
                this.$emit('rangeData', this.rangeData);
                this.closeModal();
            },
            closeModal: function () {
                this.$emit('closeModal','m-range');
            },

            deleteCustomRange: function (id) {
                this.$emit('deleteCustomRange', id);
            }
        }
    }
</script>